import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NoteAdd, Pet, PetBreed, PetCreate, PetTemplate, PetType } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class PetService {

  constructor(
    private http: HttpClient
  ) { }

  public getPets() {
    return this.http.get<{
      code: string,
      data: Array<Pet>
    }>(`${environment.host}/pet/`);
  }

  public getPetById(id: number) {
    return this.http.get<{
      code: string,
      data: Pet
    }>(`${environment.host}/pet/${id}/`);
  }

  public getTemplates(template_type: 'disease' | 'treatment', searchText?: string) {
    return this.http.get<{
      code: string,
      data: Array<PetTemplate>
    }>(`${environment.host}/note/templates?template_type=${template_type}&search=${searchText || ''}`);
  }

  public getTemplatesOnline(template_type: 'disease' | 'treatment', searchText?: string) {
    return this.http.get<{
      code: string,
      data: Array<PetTemplate>
    }>(`${environment.host}/note/online/templates?template_type=${template_type}&search=${searchText || ''}`);
  }

  public createNote(data: NoteAdd) {
    const formData = new FormData();
    formData.append('booking', data.booking.toString());
    for(let i=0; i < data.files.length; i++) {
      const file: any = data.files[i];
      if (file) {
        formData.append('files[' + i + ']file', file);
      }
    }
    
    if (data.amount) {
      formData.append('amount', data.amount);
    }

    const appointment_file: any = data.appointment_file
    if (appointment_file) {
      formData.append('appointment_file', appointment_file);
    } else {
      formData.append('reason', data.reason);
      formData.append('disease', data.disease);
      formData.append('treatment', data.treatment);
      formData.append('comments', data.comments);
      formData.append('disease_titles', data.disease_titles);
      formData.append('treatment_titles', data.treatment_titles);
    }

    return this.http.post<{
      code: string;
      data: any,
      message: string
    }>(`${environment.host}/note/create/`, formData);
  }

  public getPetTypes() {
    return this.http.get<{
      code: string,
      data: Array<PetType>
    }>(`${environment.host}/pet/pet_type/list`);
  }

  public getPetBreeds(pet_type_id: number) {
    return this.http.get<{
      code: string,
      data: Array<PetBreed>
    }>(`${environment.host}/pet/breed?pet_type_id=${pet_type_id}`);
  }

  public create(data: PetCreate) {
    data.owner = [Number(data.owner)];
    data.age = Number(data.age);

    return this.http.post<{
      code: string;
      data: any,
      message: string
    }>(`${environment.host}/pet/`, {pets: [data]});
  }
}
